import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Footer from "../../components/Footer.js";
import HeaderTransprent from "../../components/HeaderTransprent.js";
// import Button from "../../components/ui/Button.js";
// import ContactForm from "../../components/ui/ContactForm.js";
import JsonData from "../Json/leadership.json";

const Sectors = () => {

  // const formRef = useRef(null);
  const history = useHistory();
  // const [activeTab, setActiveTab] = useState("Corporate Law");

  // const handleClick = (field) => {
  //   history.push(field ? `/${field}` : "/");
  // };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // const handleScrollToForm = () => {
  //   formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  // };


  return (
    <>
      <div className="overflow-hidden">

        <section className="bg-cover bg-no-repeat bg-right w-full h-auto" style={{ backgroundImage: `url('/assets/home/index-hero-section.webp')`, }}>
          <HeaderTransprent />
          <div className="w-full h-full">
            <div className="flex flex-col w-full h-full py-16 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
              <div data-aos="fade-up" className="space-y-2 text-[#3D405B] flex flex-col justify-start items-start">
                <h1 className="xl:text-6xl text-5xl leading-[3rem] xl:leading-[3.5rem] font-bold text-white capitalize">Meet Our Experts</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-[#FFFFFF] md:py-16 py-8">
          <div className="text-center gap-10 mx-auto px-4 xl:px-0 w-full 2xl:w-9/12 xl:w-11/12">
            <div className="flex justify-center">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                {JsonData.Expertise.map((lawyer, index) => (
                  <div key={index} className="overflow-hidden cursor-pointer" onClick={() => history.push(lawyer.url)}>
                    <div className="flex items-center justify-center border-b-8 border-[#CB9B2D]">
                      <img src={lawyer.image} alt={lawyer.name} className="md:h-96 h-full object-contain" />
                    </div>
                    <div className="py-4">
                      <h1 className="text-2xl md:text-3xl text-left font-semibold textblack">{lawyer.name}</h1>
                      <p className="text-base textblack pb-5 pt-1 text-left">{lawyer.title}</p>
                      {/* <div className="flex justify-center items-center w-full">
                        <Button text="View Profile" onClick={() => history.push(lawyer.url)} />
                      </div> */}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* <section ref={formRef} className="bg-cover bg-no-repeat md:py-16 py-8 bg-[#F7F8FA]">
          <div className="flex flex-col justify-start w-full h-full 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
            <div className="mx-auto px-4 w-full">
              <div className="flex flex-col lg:flex-row">
                <div className="lg:w-1/2 flex flex-col justify-center md:mb-0 pr-0 md:pr-10 md:pt-0 pt-4">
                  <div className="flex items-center justify-center w-full">
                    <img src="/assets/home/contact-us.webp" alt="Lead with Clarity" className="z-0" />
                  </div>
                </div>
                <ContactForm />
              </div>
            </div>
          </div>
        </section> */}

        <Footer />
      </div>
    </>
  );
};


export default Sectors;
